enum LAYOUT_TYPES {
  VERTICAL = "vertical",
}

enum LAYOUT_SKIN {
  DEFAULT = "default",
}

enum LAYOUT_MODE_TYPES {
  LIGHTMODE = "light",
  DARKMODE = "dark",
}

enum LAYOUT_DIRECTION {
  LTR = "ltr",
}

enum LAYOUT_CONTENT_WIDTH {
  FLUID = "fluid",
}

enum LEFT_SIDEBAR_SIZE_TYPES {
  DEFAULT = "lg",
  SMALLICON = "sm",
}

enum LEFT_NAVIGATION_TYPES {
  STICKY = "sticky",
}

enum LEFT_SIDEBAR_COLOR_TYPES {
  LIGHT = "light",
  DARK = "dark",
}

enum LAYOUT_TOPBAR_THEME_TYPES {
  LIGHT = "light",
  DARK = "dark",
}

export {
  LAYOUT_CONTENT_WIDTH,
  LAYOUT_DIRECTION,
  LAYOUT_MODE_TYPES,
  LAYOUT_SKIN,
  LAYOUT_TOPBAR_THEME_TYPES,
  LAYOUT_TYPES,
  LEFT_NAVIGATION_TYPES,
  LEFT_SIDEBAR_COLOR_TYPES,
  LEFT_SIDEBAR_SIZE_TYPES,
};
